// extracted by mini-css-extract-plugin
export default {"root":"LogList_root__VTUEr","operation":"LogList_operation__ptlAw"};